import { render, staticRenderFns } from "./insurance-general-report.vue?vue&type=template&id=7ded456a"
import script from "./insurance-general-report.vue?vue&type=script&lang=ts"
export * from "./insurance-general-report.vue?vue&type=script&lang=ts"
import style0 from "./insurance-general-report.vue?vue&type=style&index=0&id=7ded456a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports